import { useCallback } from 'preact/hooks';

const useDataLayer = () => {
  const pushToDataLayer = useCallback((eventData) => {
    // Initialize dataLayer if it doesn't exist
    window.dataLayer = window.dataLayer || [];
    
    // Push the event
    window.dataLayer.push({
      event: eventData.event || 'custom_event',
      ...eventData
    });
  }, []);

  return { pushToDataLayer };
};

export default useDataLayer;